"use strict";
import Swiper from 'swiper/bundle';
import { toggleClassWithScroll as scroll } from "./common/_scroll-event";

let mySwiper = new Swiper("#slide", {
  loop: true,
  autoplay: true,
  speed: 500,
  slidesPerView: 3,
  spaceBetween: 30,
  breakpoints: {
    768: {
      spaceBetween: 10,
    },
  },
});
document.addEventListener("DOMContentLoaded", () => {
  const tabTriggers = document.querySelectorAll(".js-tab-trigger");

  const tabTargets = document.querySelectorAll(".js-tab-target");

  for (let i = 0; i < tabTriggers.length; i++) {
    tabTriggers[i].addEventListener("click", (e) => {
      let currentMenu = e.currentTarget;

      let currentContent = document.getElementById(currentMenu.dataset.id);

      for (let i = 0; i < tabTriggers.length; i++) {
        if (tabTriggers[i].classList.contains("is-active")) {
          tabTriggers[i].classList.remove("is-active");
        } else {
          tabTriggers[i].classList.add("is-active");
        }
      }

      currentMenu.classList.add("is-active");

      for (let i = 0; i < tabTargets.length; i++) {
        tabTargets[i].classList.remove("is-active");
      }

      if (currentContent !== null) {
        currentContent.classList.add("is-active");
      }
    });
  }
});
